import React, { useEffect, useState, useContext } from "react";
import "../Onbording.css";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import { AuthContext } from "../Hook/AuthProvider";
import { updateOnboardingStatus } from "../services/onbording";
import Onbordingimagecomponent from "./onbordingImgae";
import dayjs from "dayjs";
import ImageComponent from "./imageComponent";

const Onboarding = ({ onComplete }) => {
   const years = [2026, 2027, 2028];
  const [selectedYear, setSelectedYear] = useState();
  const [open, setOpen] = useState(false);
  const [next, setNext] = useState(false);
  const [cont, setCont] = useState(false);
  const [finish, setFinish] = useState(false);
  const [skip, setSkip] = useState(false);
  const [journey, setJourney] = useState("");
  const [isProgressComplete, setIsProgressComplete] = useState(false);
  const currentYear = new Date().getFullYear();
  const [index, setIndex] = useState(0);
  const { fetchProfile } = useContext(AuthContext);
  const navigate = useNavigate();
    const [yearError, setYearError] = useState("");
  const [journeyError, setJourneyError] = useState("");
  const data = [
    {
      heading: "Your responses have been saved",
      paragraph:
        "Setting up Yooki to match your UPSC preparation for better guidance.",
      "note-img": "/assets/images/Input text.svg",
      "prog-img": "/assets/images/progressbar-bottom-1.png",
    },
    {
      heading: "Setting up Yooki...",
      paragraph:
        "Setting up Yooki to match your UPSC preparation for better guidance.",
      "note-img": "/assets/images/Input text1.svg",
      "prog-img": "/assets/images/progressbar-bottom-2.png",
    },
    {
      heading: "Setting up Yooki...",
      paragraph:
        "Setting up Yooki to match your UPSC preparation for better guidance.",
      "note-img": "/assets/images/Input text2.svg",
      "prog-img": "/assets/images/progressbar-bottom-3.png",
    },
  ];


  useEffect(() => {
    let timer;
    if (skip && !isProgressComplete) {
      if (index < data.length - 1) {
        timer = setTimeout(() => {
          setIndex((prev) => prev + 1);
        }, 2000);
      } else if (index === data.length - 1) {
        timer = setTimeout(async () => {
          setIsProgressComplete(true);
          await updateOnboardingStatus(selectedYear, journey);
          await fetchProfile();
          navigate(ROUTES.DASHBOARD);
        }, 2000);
      }
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [
    index,
    skip,
    isProgressComplete,
    data.length,
    navigate,
    selectedYear,
    journey,
    fetchProfile,
  ]);

  const handleSubmit = async () => {
    setCont(false);
    setNext(false);
    setFinish(true);

    try {
      await updateOnboardingStatus(selectedYear, journey);
      await fetchProfile();
      navigate(ROUTES.DASHBOARD);
    } catch (error) {
      console.error("Error updating onboarding status:", error);
    }
  };

  const handleSkip = async () => {
    setSkip(true);
    // setIndex(0);
    try {
      await updateOnboardingStatus(null, "");
      await fetchProfile();
      navigate(ROUTES.DASHBOARD);
    } catch (error) {
      console.error("Error updating onboarding status:", error);
    }
  };

  const handleFinish = async () => {
    setFinish(true);
    try {
      await updateOnboardingStatus(selectedYear, journey);
      await fetchProfile();
      navigate(ROUTES.DASHBOARD);
    } catch (error) {
      console.error("Error updating onboarding status:", error);
    }
  };

  // const years = Array.from({ length: 50 }, (_, i) => currentYear - i);
  return (
    <div className="onboarding-container">
      {!skip && (
        <div className="p-div" style={{ display: "flex" }}>
          <div className="c1-div">
            <img
              src="/assets/images/logo/SVG/Logo-Org.svg"
              alt="star"
              className="icon"
              style={{  width:"100px" }}
            />
            {!next && !cont && !finish && (
              <div className="msg-div">
                <img
                  src="/assets/images/onbording-icon.svg"
                  alt="star"
                  className="blinking-icon"
                  style={{
                    animation: "blink 1s infinite",
                    "@keyframes blink": {
                      "0%": { opacity: 1 },
                      "50%": { opacity: 0.3 },
                      "100%": { opacity: 1 },
                    },
                  }}
                />
                <p className="klo">
                  Personalise Yooki to your UPSC preparation
                </p>
                <p className="para">
                  Providing this information ensures more relevant guidance and
                  study recommendations.
                </p>
                <div className="but">
                  <div>
                    <button
                      className="but11"
                      type="submit"
                      style={{ background: "#5ab4de" }}
                      onClick={() => setNext(true)}
                    >
                      Set Up My Prep
                    </button>
                  </div>

                  <div>
                    <button
                      className="but21"
                      type="submit"
                      onClick={handleSkip}
                    >
                      Skip for now
                    </button>
                  </div>
                </div>
              </div>
            )}

            {next && !cont && (
              <div className="msg-div">
                <img
                  src="/assets/images/progressbar1.png"
                  alt="Progress bar"
                  className="progress-bar"
                />
                <p className="klo1">Which year are you targeting for UPSC?</p>
                <div>
                  <div className="year-selector">
                    {years.map((year) => (
                      <div
                        key={year}
                        className={`year-item ${
                          selectedYear === year ? "active" : ""
                        }`}
                        onClick={() => {
                          setSelectedYear(year);
                          setYearError("");
                        }}
                      >
                        {year}
                      </div>
                    ))}
                  </div>
                  {yearError && (
                    <div style={{ color: "red", marginTop: "8px" }}>{yearError}</div>
                  )}
                  <div>
                    <Onbordingimagecomponent text={"This helps us tailor Yooki to give you responses & help complete your syllabus as per your UPSC exam year."}/>
                  </div>
                  <button
                    className="but11"
                    type="submit"
                    style={{ background: "#5ab4de", marginTop: "150px" }}
                    onClick={() => {
                      if (!selectedYear) {
                        setYearError("Please select year");
                      } else {
                        setYearError("");
                        setCont(true);
                      }
                    }}
                  >
                    Continue
                  </button>
                </div>
              </div>
            )}

            {cont && (
              <div className="msg-div">
                <img
                  src="/assets/images/progressbar2.svg"
                  alt="Progress bar"
                  className="progress-bar"
                />
                <div className="klo1">
                  Where do you stand in your UPSC journey?
                </div>
                <div>
                  <div className="radio-container">
                    <input
                      type="radio"
                      id="fresher"
                      value="Fresher (Trial Attempt)"
                      checked={journey === "Fresher (Trial Attempt)"}
                      onChange={(e) => {
                        setJourney(e.target.value);
                        setJourneyError("");
                      }}
                    />
                    <label htmlFor="fresher">Fresher (Trial Attempt)</label>
                  </div>
                  <div className="radio-container">
                    <input
                      type="radio"
                      id="fresher"
                      value="Fresher (First Attempt)"
                      checked={journey === "Fresher (First Attempt)"}
                      onChange={(e) => {
                        setJourney(e.target.value);
                        setJourneyError("");
                      }}
                    />
                    <label htmlFor="fresher">Fresher (First Attempt)</label>
                  </div>

                  <div className="radio-container">
                    <input
                      type="radio"
                      id="repeater"
                      value="Repeater (Prelims Never Qualified)"
                      checked={journey === "Repeater (Prelims Never Qualified)"}
                      onChange={(e) => {
                        setJourney(e.target.value);
                        setJourneyError("");
                      }}
                    />
                    <label htmlFor="repeater">
                      Repeater (Prelims Never Qualified)
                    </label>
                  </div>

                  <div className="radio-container">
                    <input
                      type="radio"
                      id="cleared-prelims"
                      value="Repeater (Prelims Qualified)"
                      checked={journey === "Repeater (Prelims Qualified)"}
                      onChange={(e) => {
                        setJourney(e.target.value);
                        setJourneyError("");
                      }}
                    />
                    <label htmlFor="cleared-prelims">
                      Repeater (Prelims Qualified)
                    </label>
                  </div>

                  <div className="radio-container">
                    <input
                      type="radio"
                      id="cleared-mains"
                      value="Repeater (Mains Qualified)"
                      checked={journey === "Repeater (Mains Qualified)"}
                      onChange={(e) => {
                        setJourney(e.target.value);
                        setJourneyError("");
                      }}
                    />
                    <label htmlFor="cleared-mains">
                      Repeater (Mains Qualified)
                    </label>
                  </div>
                </div>
                {journeyError && (
                  <div style={{ color: "red", marginTop: "8px" }}>{journeyError}</div>
                )}
                <div>
                   <Onbordingimagecomponent text={"This helps Yooki understand your preparation stage and provide better guidance."}/>
                </div>
                <button
                  className="but11"
                  type="submit"
                  style={{ background: "#5ab4de", marginTop: "120px" }}
                  onClick={() => {
                    if (!journey) {
                      setJourneyError("Please select your UPSC journey");
                    } else {
                      setJourneyError("");
                      handleSubmit();
                    }
                  }}
                >
                  Finish
                </button>
              </div>
            )}
          </div>

          <div className="c2-div">
            <ImageComponent />
            {/* <img
              src="assets/images/onbording.svg"
              alt="star"
              className="c2-img"
            /> */}
          </div>
        </div>
      )}

      {skip && (
        <div className="onboarding-content">
          <img
            src="/assets/images/logo/SVG/Logo-Org.svg"
            alt="star"
            className="icon"
            style={{ padding: "30px", width:"104px", height:"48px"  }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "5%",
            }}
          >
            <img
              src="/assets/images/onbording-icon.svg"
              alt="star"
              className="blinking-icon skip-icon"
              style={{
                animation: "blink 1s infinite",
                "@keyframes blink": {
                  "0%": { opacity: 1 },
                  "50%": { opacity: 0.3 },
                  "100%": { opacity: 1 },
                },
              }}
            />
            <div className="skip-h">{data[index].heading}</div>
            <div className="skip-p">{data[index].paragraph}</div>
            <div className="bot-part">
              <div style={{ height: "80px" }}>
                <img
                  src={data[index]["note-img"]}
                  alt="note"
                  style={{ marginTop: "30px" }}
                  className="mb-view"
                />
              </div>
              <div style={{ textAlign: "center" }}>
                <img
                  src={data[index]["prog-img"]}
                  alt="progress"
                  style={{ marginTop: "30px" }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Onboarding;
